import internalFetch from "./axios-instance";
import {getAuthorizationHeader} from "../helpers/get-token";

export const getKelkooReportService = async dates => await internalFetch.post('/kelkoo/reports', dates, {
    headers: { 'Authorization': getAuthorizationHeader() }
});

